export default "__VITE_ASSET__CQqaWqLQ__"